import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import 'datatables.net-buttons/js/dataTables.buttons.min.js';
import 'datatables.net-buttons/js/buttons.html5.min.js';
import 'datatables.net-buttons/js/buttons.print.min.js';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import jszip from 'jszip';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { API_URL } from '..';
window.JSZip = jszip;
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const InvoiceListLayer = ({jobsData}) => {
  const history = useNavigate();
  const [currentUser, setCurrentUser]= useState({})
      const handleDelete = async(id)=>{
        const user = JSON.parse(localStorage.getItem('user'))
        
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         let response = await fetch(`${API_URL}/api/invoice/delete-invoice/${user.id}/${id}`, { 
           method: "DELETE",
           headers: headersList
         });
         let data = await response.json();
         if(data.message=="Invoice deleted successfully"){
            window.location.reload();
         }
      }
      const changeStatusFunction = async (id, status) => {
        try {
          const headersList = {
            Accept: "*/*",
            "Content-Type": "application/json",
          };
          const bodyContent = JSON.stringify({
            invoice_id: id,
            status: status,
          });
    
          const response = await fetch(`${API_URL}/api/invoice/update-status`, {
            method: "PUT", // Adjust method as per your API
            headers: headersList,
            body: bodyContent,
          });
    
          if (response.status === 200) {
            console.log(`Status updated for invoice ${id} to ${status}`);
            
            // Optionally update jobsData state here if needed
          } else {
            console.error("Failed to update status:", response.statusText);
          }
        } catch (error) {
          console.error("Error updating status:", error);
        }
      };
    
      // Attach changeStatusFunction to window immediately
      useEffect(() => {
        window.changeStatusFunction = changeStatusFunction;
        return () => {
          delete window.changeStatusFunction; // Cleanup on unmount
        };
      }, []);
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'))
      setCurrentUser(user)
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
        dom: 'Bfrtip',
        buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
         columns: [
            { data: 'invoice_number' },
            { data: 'customer_name' },
            { data: 'phone' },
            { data: 'due_date' },
            { data: 'amount' ,
            render: function (data, type, row) {
                // Return HTML string for buttons
                return `
               <span>${parseFloat(data).toFixed(2)}</span>
               
                `;
              }, },
            { data: 'status' , render: function (data, type, row) {
              // Pass row.id and selected value to changeStatusFunction
              return `
                <select class="form-control" onchange="window.changeStatusFunction('${row.id}', this.value)">
                  <option value="Paid" ${data === "Paid" ? "selected" : ""}>Paid</option>
                  <option value="Unpaid" ${data === "Unpaid" ? "selected" : ""}>Unpaid</option>
                </select>
              `;
            }, },
           
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <div class="dropdown">
                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ph ph-list"></i>
                </button>
                <ul class="dropdown-menu">
                
                  <li><a style="cursor:pointer" href="${row.recepit_url}" target="_blank"  class="dropdown-item"><i class="ph ph-file-text"></i> Print Invoice</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Invoice</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Invoice</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Invoice</a></li>
                </ul>
              </div>
                
             
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          const id = $(this).data('id');
          history(`/edit-invoice/${id}`); // Navigate to the edit page
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
          history(`/view-invoice/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);
  
    return (
        <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">Invoices</h5>
            <div class="col-md-6 text-end">
            <Link className="btn btn-info" to={'/add-invoice'}>
              Add New
            </Link>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
                <th scope="col">InvoiceNo</th>
                <th scope="col">Customer Name</th>
                <th scope="col">Customer Phone</th>
                <th scope="col">Due Date</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default InvoiceListLayer